// <!-- LEGAL REVIEW REQUIRED --> Template only. Placeholders are in LEGAL_TODO.md.
import React from 'react';
import { LegalList, LegalPage } from '../../components/ui';
import { CONTACT_EMAIL, LEGAL_UPDATED } from '../../lib/legal';

const SECTIONS = [
  {
    title: '1. What We Use',
    body: 'This website does not set cookies, and it does not use analytics or advertising pixels. It keeps one small setting in your own browser, which are never sent to us:',
  },
  {
    title: '2. Setting Stored in Your Browser',
    body: (
      <LegalList
        items={[
          'Whether you have already visited during this browsing session, so we can show you the right first page. Cleared when you close the tab.',
        ]}
      />
    ),
  },
  {
    title: '3. Stripe Checkout',
    body: "When you go to checkout you leave this website for Stripe's hosted payment page. Stripe may set its own cookies there for payment and fraud prevention, as described in Stripe's privacy policy.",
  },
  {
    title: '4. If This Changes',
    body: 'If we add analytics or other non-essential cookies, we will update this notice first and ask for consent where the law requires it.',
  },
  {
    title: '5. Questions',
    body: `Email ${CONTACT_EMAIL}.`,
  },
];

const Cookies = () => <LegalPage title="Cookie Notice" updated={LEGAL_UPDATED} sections={SECTIONS} />;

export default Cookies;
